import React, { useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import ReactTooltip from "react-tooltip";
import "./InfoPopup.scss";

interface Props {}

const InfoPopup: React.FC<Props> = ({ children }) => {
  const overridePosition = useCallback(
    ({ left, top }) => ({
      left: left > 0 ? left : 0,
      top,
    }),
    []
  );
  return (
    <span className="info-popup" onClick={(event) => event.stopPropagation()}>
      <span className="info-popup__icon" data-tip={children}>
        <FontAwesomeIcon icon={faInfo} />
      </span>
      <ReactTooltip
        className="info-popup__tooltip"
        effect="solid"
        multiline={true}
        overridePosition={overridePosition}
      />
    </span>
  );
};

export default InfoPopup;
